module.exports = __webpack_public_path__ + "media/landing_parts/icons/ferpa-eef245c51e0388d76235d901d65e55c4.png";